import { create } from "zustand";

interface PersonalDataState {
  telefone: string | null;
  email: string | null;
  emailEmpresa: string | null;
  telefoneEmpresa: string | null;
  aceite: boolean;
  whatsappVerified: boolean;
  setPersonalData: (
    telefone: string,
    email: string,
    emailEmpresa?: string,
    telefoneEmpresa?: string
  ) => void;
  setAceite: (aceite: boolean) => void;
  setWhatsappVerified: (verified: boolean) => void;
  clearPersonalData: () => void;
}

export const usePersonalDataStore = create<PersonalDataState>((set) => ({
  telefone: null,
  email: null,
  emailEmpresa: null,
  telefoneEmpresa: null,
  aceite: false,
  whatsappVerified: false,
  setPersonalData: (telefone, email, emailEmpresa, telefoneEmpresa) =>
    set({
      telefone,
      email,
      emailEmpresa: emailEmpresa ?? null,
      telefoneEmpresa: telefoneEmpresa ?? null,
    }),
  setAceite: (aceite) => set({ aceite }),
  setWhatsappVerified: (verified) => set({ whatsappVerified: verified }),
  clearPersonalData: () =>
    set({
      telefone: null,
      email: null,
      emailEmpresa: null,
      telefoneEmpresa: null,
      aceite: false,
      whatsappVerified: false,
    }),
}));
